import React from 'react'
import { SVGIconProps } from '../types'
const SvgGrapheq = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="currentColor"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h16v16H0z" />
      <path
        fill="#233745"
        fillRule="nonzero"
        d="M4.667 12H6V4H4.667zm2.666 2.667h1.334V1.333H7.333zM2 9.333h1.333V6.667H2zM10 12h1.333V4H10zm2.667-5.333v2.666H14V6.667z"
      />
    </g>
  </svg>
)
export default SvgGrapheq
